import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { optimizedImage, fallbackToOriginal } from '../utils/imageUrl';
const MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/wVyuNdyu6KZi89Arcrndgk/BIBLIA_TRADICIONAL_(5).png';
const BULLETS = ['Leen por iniciativa propia: sin pelear, sin rogar, sin negociar', 'Cada historia con su referencia bíblica, para dar el salto a la Biblia real', 'En su tablet, en tu celular o impresa: la llevas a todos lados'];
export function Hero() {
  return <section className="w-full bg-[#10243D]" data-id="element-64" data-mp="sb1efy4p8fa9">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-5 px-4 py-5 md:grid-cols-12 md:gap-10 md:py-10" data-id="element-65" data-mp="s9q7xqjvctfg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="md:col-span-7" data-id="element-66" data-mp="nekmstyajisf">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.15em] text-gold sm:text-sm" data-id="element-67" data-mp="384jud2bfbpui">
            La Biblia completa en formato cómic · De Génesis a Apocalipsis
          </p>
          <h1 className="font-sans text-[32px] font-extrabold uppercase leading-[1.08] tracking-[-0.035em] text-white sm:text-5xl md:text-[54px]" data-id="element-68" data-mp="3o6u7fbahgtdg">
            Tu hijo cree que la Biblia es{' '}
            <span className="mark-gold" data-id="element-69" data-mp="3e7uzxw1gf3s1">aburrida</span>. Hasta que ve esta.
          </h1>

          <motion.img initial={{
          opacity: 0,
          y: 18,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.65,
          delay: 0.15
        }} src={optimizedImage(MOCKUP_SRC, 900)} onError={event => fallbackToOriginal(event, MOCKUP_SRC)} alt="La Biblia en Cómic: edición impresa junto a la versión digital en tablet" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="async" sizes="(min-width: 768px) 448px, 300px" className="mx-auto mt-3 h-auto w-full max-w-[300px] drop-shadow-2xl sm:max-w-sm md:mx-0 md:mt-5 md:max-w-md" data-id="element-70" data-mp="30h9ebzkm8fqg" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 18
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="md:col-span-5" data-id="element-71" data-mp="ic89fikzqczf">
          <p className="text-[17px] leading-relaxed text-cream/90 md:text-lg" data-id="element-72" data-mp="1b0nkju104b5h">
            Historias <strong className="font-bold text-gold" data-id="element-73" data-mp="161t1cqz4gkku">fieles a la Escritura</strong>,
            ilustradas como sus historietas favoritas, para que la Palabra deje
            de ser una obligación y{' '}
            <strong className="font-bold text-gold" data-id="element-74" data-mp="x14ldqq64a5b">
              se convierta en su historia favorita
            </strong>
            .
          </p>

          <div className="mt-5 flex justify-center md:justify-start" data-id="element-75" data-mp="3luiaiu6w15my">
            <CtaButton label="QUIERO QUE AME LA PALABRA" size="lg" onDark data-id="element-76" data-mp="3hr3rdunnk95a" />
          </div>

          <ul className="mt-6 space-y-3" data-id="element-77" data-mp="1x9ujo7n357lu">
            {BULLETS.map(b => <li key={b} className="flex items-start gap-3" data-id="element-78" data-mp="21awf0ddvszij">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-gold" data-id="element-79" data-mp="21b647yr3r2n6">
                  <CheckIcon className="h-4 w-4 text-deep-blue" aria-hidden="true" data-id="element-80" data-mp="267wlgpen84a6" />
                </span>
                <span className="text-[16px] leading-relaxed text-cream md:text-[17px]" data-id="element-81" data-mp="2b2kbwtt7j8re">
                  {b}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>

      <div className="border-t border-gold/30 bg-[#10243D]" data-id="element-82" data-mp="2p0h5riga112d">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-1.5 px-4 py-3 text-center sm:flex-row sm:gap-3" data-id="element-83" data-mp="2p1a5w0kqcsbj">
          <span className="flex text-gold" aria-hidden="true" data-id="element-84" data-mp="umppi03fzixy">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold" data-id="element-85" data-mp="zkr9cn8ozmah" data-mpi={i} />)}
          </span>
          <p className="text-sm font-medium text-cream/80 md:text-[15px]" data-id="element-86" data-mp="4auo8pqfqxn9">
            El formato que ya conquistó a millones de familias en todo el mundo
          </p>
        </div>
      </div>
    </section>;
}